import Base from '../../_config/base';

class Share extends Base {
  constructor(el) {
    super(el);

    this.shareButton = el.querySelector('.share-button');
    this.buttonsWrapper = el.querySelector('.share__links');
    this.closeShare = el.querySelector('.close-share');
    this.openShare = el.querySelector('.open-share');

    this.shareButton.onclick = () => {
      if (this.buttonsWrapper.classList.contains('active')) {
        this.buttonsWrapper.classList.remove('active');
        this.closeShare.classList.add('hidden');
        this.openShare.classList.remove('hidden');
      } else {
        this.buttonsWrapper.classList.add('active');
        this.closeShare.classList.remove('hidden');
        this.openShare.classList.add('hidden');
      }
    };
  }
}

Share.className = 'Share';
export default Share;
